import axios from "axios";
import { useEffect, useState } from "react";
import { useRef } from "react";
import { AiOutlineDoubleLeft } from "react-icons/ai";
import { AiOutlineDoubleRight } from "react-icons/ai";
import { Link, useNavigate } from "react-router-dom";

import { BiSearch } from "react-icons/bi";
import "./style.css";
// import "./newStyle.css";
import React from "react";
import PopupAHSF from "../PopupAHSF/index";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment-timezone";
import loadConfig from "../../Services/Api/ApiServices";
import { motion } from "framer-motion";
import {
  faTrashAlt,
  faFile,
  faCircleExclamation,
  faEye,
  faFolderOpen,
  faPaperclip,
  faSearch,
  faTrash,
  faCirclePlus,
  faSquarePlus,
  faAdd,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { decryptToken } from "../../Services/Encryption/EncryptionToken";
// import { SetArrayDataCheckBoks } from "../../Redux/Reducers/Shared/CheckBox";
import ButtonAHSF from "../ButtonAHSF";
import { SetArrayDataCheckBoks } from "../../Redux/Reducers/Shared/CheckBox";
import LoaderAHSF from "../LoaderAHSF";
//----------------------------props----------------------------------------
// DropdownArrayFiltration  ----> dropdown الخاصة ب الجدول للفلترة لاظهار
// arrayButton ----> الجزئية الخاصة بالقامة بالازرار الخاصة بالصفوف
//openPopupState ----> لفتح واغلاق الpopoup الخاصة بالاضافة او التعديل
//tableId ---> الid الخاص بالجدول والذي من خلاله يتم تمييز الجدول في redux
//TableComponent ---> لاظهار الcomponent فوق الجدول
//mergeColumns ---> لجعل الجدول يظهر ك grouping نرسل خلالها اسماء الاعمدة التي يحصل عليها الدمج
//ShowHideBtn ---> للتحكم في طريقة عرض الازار على الصفوف بناء على شرطوقيمة معينة
//titelTableEN ==> اسم الجدول للغة الانجليزية
const TableAHSF = (props) => {
  const [options, setOptions] = useState(props.DropdownArrayFiltration);
  const [filterRefrish, setFilterRefrish] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [arrayButton, SetArrayButton] = useState(props.arrayButton);
  const [arrayButtonLast, SetArrayButtonLast] = useState(props.arrayButtonLast);
  const [arrayNameDataColum, SetArrayNameDataColum] = useState(
    props.ArrayNameDataColum
  );
  const [stebPagination, setStebPagination] = useState(0);
  const [endpagination, setEndPagination] = useState(5);
  const [stateSort, setStateSort] = useState();
  // const [arrayDataCheckBoks, setArrayDataCheckBoks] = useState([]);
  const [halfPageNumber, setHalfPageNumber] = useState(5);
  const [res, setRes] = useState([]);
  const [total, setTotal] = useState([]);
  const [filterData, SetFilterData] = useState([]);
  const [refreshFilter, setRefreshFilter] = useState(false);
  const [valueFilterSupDropDown, SetvalueFilterSupDropDown] = useState("");
  const [hideDropDown, setHideDropDown] = useState("");
  const [loading, setLoading] = useState(true);
  const [openPopupState, setopenPopupState] = useState(props.openPopupState);
  const [isOpen, setIsOpen] = useState(false);
  const [accessToken, setAccessToken] = useState("");
  ////////////////

  const [mainFiltration, setMainFiltration] = useState([]);
  const [hover, setHover] = useState(false);

  const [jsonData, setJsonData] = useState({});
  const [jsonLoding, setJsonLoding] = useState(false);
  const [selectedOptions, setSelectedOptions] = useState([]); // Track selected checkboxes
  // const language = useSelector((state) => state.languageReducer.Language);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // useEffect(() => {
  //   setOptions(props.DropdownArrayFiltration);
  // }, [props.DropdownArrayFiltration]);

  const state = useSelector((state) => {
    return {
      refreshTableStatus: state.refreshTableStatus.refreshTable,
      arrayDataCheckBoks: state.arrayDataCheckBoks.arrayDataCheckBoks,
    };
  });
  const refresh = useSelector(
    (state) => state.refreshTableStatus.refreshTable[props.tableId]
  );
  const getJson = async () => {
    var json = await loadConfig();
    setJsonData(json);
    setJsonLoding(true);
  };

  // const accessTokenFun = async () => {
  //   if (window.location.href.includes("manager")) {
  //     let accessToken = await decryptToken("AccessTokenManager", "manager");
  //     setAccessToken(accessToken);
  //   } else {
  //     let accessToken = await decryptToken("AccessToken", "sso");
  //     setAccessToken(accessToken);
  //   }
  // };
  // console.log(valueFilterSupDropDown, "sdjkhsdjsjhd");

  useEffect(() => {
    // console.log(`${jsonData.domainUrl}/${props.URL}`, "malekgggggggggggg");

    // accessTokenFun();

    getJson();
    setLoading(true);
    console.log(jsonData.domainUrl, "jsonData");

    if (
      jsonData.domainUrl != null &&
      jsonData.domainUrl != undefined &&
      jsonData.domainUrl != "undefined"
    ) {
      axios
        .post(`${jsonData.domainUrl}/${props.URL}`, props.UrlBody, {
          headers: {
            Authorization: `${sessionStorage.getItem("AccessToken")}`,
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          setRes(response.data.result);
          SetFilterData(response.data.result);
          setRefreshFilter(false);
          setLoading(false);
          // console.log(response.data, "tyutyus");
        })
        .catch((err) => {
          // console.log(err, "error");
          setLoading(false);
        });
    }

    //////////////////////////////////////// handel check box List when next to page //////////////////////////////////////
    Array.from(document.getElementsByClassName("checkboxList")).map(
      (ele, ind) => {
        ele.checked = false;
      }
    );
    //here
    state?.arrayDataCheckBoks[props.uniqeKeyNameRedux]?.map((ele, ind) => {
      console.log(ele, "eeeeeeeeeeeeeeeeeee");

      if (document.getElementById(ele.userGUID) !== null) {
        document.getElementById(ele.userGUID).checked = true;
      }
    });
    //here
    //////////////////////////////////////// End handel check box List when next to page //////////////////////////////////
  }, [filterRefrish, jsonLoding, refresh, localStorage.getItem("lang")]);
  ////////////////////////////////////////////////////////////////// handel dropDownfilteration
  //to sort array column
  const sortedAccessor = [...props.accessor].sort((a, b) => {
    return (a.sortColumn ?? Infinity) - (b.sortColumn ?? Infinity);
  });
  useEffect(() => {
    // Helper function to filter unique objects based on specific properties
    function uniqueByProperties(arr, props) {
      return arr.filter(
        (obj, index, self) =>
          index ===
          self.findIndex((t) => props.every((prop) => t[prop] === obj[prop]))
      );
    }

    let array = []; // Initialize an empty array to hold transformed options
    // Loop through the 'res' array to extract dropdown options
    res.map((element) => {
      return props.accessor.map((element_) => {
        if (
          element_.DropdownFiltrationStatus &&
          element[element_?.KeyName] != null
        ) {
          // console.log(element_, "sdsdddddddsdsd");
          // Push transformed dropdown option into the array
          array.push({
            label: element[element_.DropdownFiltration.keyTextName], // Display text
            value: element[element_.DropdownFiltration.keyValueName], // Option value
            keyName: element_?.KeyName,
            keyValueName: element_.DropdownFiltration.keyValueName, // Value key
            groping: element_.NmaeColumn, // Grouping category
            // tableNameShow: "kkk",
          });
        }
      });
    });

    // Filter out any options with null values
    let filteredArray = array.filter((item) => item.value !== null);
    // Get unique objects based on 'value' and 'keyName' properties
    let uniqueObjects = uniqueByProperties(filteredArray, ["value", "keyName"]);
    setOptions(uniqueObjects);
  }, [res, props.accessor]);

  const handleCheckboxChange = (option, e) => {
    if (e.target.checked) {
      // Add the selected option
      setSelectedOptions((prev) => [
        ...prev,
        { key: option.keyValueName, value: option.value },
      ]);
    } else {
      // Remove the deselected option
      setSelectedOptions((prev) =>
        prev.filter(
          (selected) =>
            selected.key !== option.keyValueName ||
            selected.value !== option.value
        )
      );
    }
  };

  let filteredData = res;

  const groupedOptions = selectedOptions.reduce((acc, { key, value }) => {
    if (!acc[key]) acc[key] = []; // Initialize group if not already present
    acc[key].push(value); // Add value to the corresponding group
    return acc;
  }, {});
  // Filter the data based on the selected options
  filteredData = Object.entries(groupedOptions).reduce(
    (data, [key, values]) => {
      // Filter data where the key's value is included in the selected values
      return data.filter((option) => values.includes(option[key]));
    },
    filteredData
  );

  // console.log(filteredData, "filteredData");

  ///////////////////////////////////////////////////////// end dropDownfilteration

  ///////////////////// customize search function /////////////////////////////////
  var arabicNormChar = {
    ك: "ک",
    ﻷ: "لا",
    ؤ: "و",
    ى: "ی",
    ي: "ی",
    ئ: "ی",
    أ: "ا",
    إ: "ا",
    آ: "ا",
    ٱ: "ا",
    ٳ: "ا",
    ة: "ه",
    ء: "",
    "ِ": "",
    "ْ": "",
    "ُ": "",
    "َ": "",
    "ّ": "",
    "ٍ": "",
    "ً": "",
    "ٌ": "",
    "ٓ": "",
    "ٰ": "",
    "ٔ": "",
    " ": "",
  };
  const simplifyArabic = (value) => {
    return value
      .replace(/[^\u0000-\u007E]/g, function (option) {
        var retval = arabicNormChar[option];

        if (retval == undefined) {
          retval = option;
        }
        return retval;
      })
      .normalize("NFKD")
      .toLowerCase();
  };

  /////////////////////////End customize search function ///////////////////////////////////////

  ///////////////////////////handel Search function to filter data table ////////////////////////
  const dropdownRef = useRef(null);
  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsOpen(false);
      setHideDropDown("hide");
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handelSearch = (e) => {
    setRes(filterData);
    setRes(
      filterData.filter((opject, ind) => {
        console.log(opject, "obj");
        return simplifyArabic(Object.values(opject).join("")).includes(
          simplifyArabic(e.target.value)
        );
      })
    );
    console.log(filterData, "search");
  };

  //////////////////////////////////////////Sum column////////////////////////////////////////////////////
  const numberWithCommas = (x) => {
    if (x != null) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
  };
  const calculatorColumn = (columnKeyName) => {
    console.log(columnKeyName, "sdssssssssxsdwdwdwd");

    let sum = 0;
    sum = res.reduce((accumulator, currentValue) => {
      console.log(currentValue[columnKeyName], "sdsdsdsdsddd");

      return accumulator + Number(currentValue[columnKeyName]);
    }, 0);
    return sum;
  };
  //////////////////////////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////// ColumnsOperation function/////////////////////////
  const ColumnsOperation = (columnKeyNameArray) => {
    let sum = 0;

    columnKeyNameArray.map((keyNAme, ind) => {
      sum = res.reduce((accumulator, currentValue) => {
        return currentValue[keyNAme]
          ? accumulator + Number(currentValue[keyNAme])
          : 0;
      }, 0);
    });
    // console.log(numberWithCommas(sum), "sum");
    return numberWithCommas(sum);
  };
  ///////////////////////////////////////////End ColumnsOperation function/////////////////////////

  const tableRef = useRef(null);
  //////////////////////end function////////////////////////////////////////////////////////////

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const groupingDropDown = () => {
    const groupedOption = {};
    options.forEach((ele, ind) => {
      if (!groupedOption[ele.groping]) {
        groupedOption[ele.groping] = [];
      }
      groupedOption[ele.groping].push(ele);
    });

    return groupedOption;
  };

  // useEffect(() => {
  //   console.log(arrayDataCheckBoks, "arr");
  // }, [arrayDataCheckBoks]);
  // this line convert array of opject to array of string
  const keyNames = sortedAccessor.map((item) => item?.KeyName);
  useEffect(() => {
    if (props.setEndPagination) {
      setEndPagination(100);
    }
  }, {});

  ////////////////////////////////////////////////////////////////////////////////
  //  دالة لتجميع الصفوف حسب قيم الأعمدة المدمجة مع الحفاظ على ترتيب البيانات
  const groupDataByKeys = (data, mergeColumns) => {
    const groupsMap = new Map();
    const groupsOrder = []; // للحفاظ على ترتيب ظهور المجموعات

    data.forEach((row) => {
      const key = mergeColumns.map((col) => row[col]).join("|");

      if (!groupsMap.has(key)) {
        groupsMap.set(key, []);
        groupsOrder.push(key);
      }

      groupsMap.get(key).push(row);
    });

    return groupsOrder.map((key) => groupsMap.get(key));
  };

  ///-----------------------------------------------------------
  // دالة لتحويل القيم حسب نوع العمود
  const renderContent = (col, cellValue) => {
    if (col.comma) return numberWithCommas(cellValue);
    if (col?.KeyName === props.dateKey || col?.KeyName === props.dateKey2)
      return moment(cellValue).format(props.dateformat);
    if (col.typeColumn === "file" && cellValue) {
      console.log(cellValue, "cel");

      return (
        <Link target="_blank" to={`${jsonData.domainUrl}/${cellValue}`}>
          <button className="open-file">Open</button>
        </Link>
      );
    }
    if (cellValue === true) return props.trueText;
    if (cellValue === false) return props.falseText;
    return cellValue;
  };
  const allowMerge = (row, rowIndex) => {
    if (props.mergeCondition) {
      return props.mergeCondition(row, rowIndex);
    } else {
      return true;
    }
  };

  // Function to handle "Select All" checkbox - ALL DATA
  const handleSelectAll = (e) => {
    const isChecked = e.target.checked;

    if (isChecked) {
      // Select ALL data (not just current page)
      const allRowsData = filteredData || [];
      // console.log(allRowsData,"dsssssssssdwd");

      let newallRowsData = allRowsData.filter((ele) => {
        return props.checkBoksCustomRenderKeyValue.includes(
          ele[props.checkBoksCustomRenderKeyName]
        )
          ? props.checkBoksCustomRenderKeyValue.includes(
              ele[props.checkBoksCustomRenderKeyName]
            ) && props.checkBoksCustomRenderShowOrHide
          : true;
      });

      console.log(newallRowsData, "dffefefefef");

      dispatch(
        SetArrayDataCheckBoks({
          array: newallRowsData,
          KeyName: props.uniqeKeyNameRedux,
        })
      );

      // Check all checkboxes
      Array.from(document.getElementsByClassName("checkboxList")).forEach(
        (ele) => {
          ele.checked = true;
        }
      );
    } else {
      // Deselect all
      dispatch(
        SetArrayDataCheckBoks({
          array: [],
          KeyName: props.uniqeKeyNameRedux,
        })
      );

      // Uncheck all checkboxes
      Array.from(document.getElementsByClassName("checkboxList")).forEach(
        (ele) => {
          ele.checked = false;
        }
      );
    }
  };

  // Check if ALL data is selected (not just current page)
  const areAllDataSelected = () => {
    const allData = filteredData || [];
    if (allData.length === 0) return false;

    const selectedRows =
      state?.arrayDataCheckBoks[props.uniqeKeyNameRedux] || [];

    // Create a Set of selected row IDs for faster lookup
    const selectedIds = new Set(
      selectedRows.map((row) => row[props.uniqeKeyName])
    );

    // Filter data based on checkBoksCustomRender condition - SAME LOGIC AS handleSelectAll
    const applicableData = allData.filter((ele) => {
      if (props.checkBoksCustomRender) {
        return props.checkBoksCustomRenderKeyValue.includes(
          ele[props.checkBoksCustomRenderKeyName]
        )
          ? props.checkBoksCustomRenderKeyValue.includes(
              ele[props.checkBoksCustomRenderKeyName]
            ) && props.checkBoksCustomRenderShowOrHide
          : true;
      }
      return true;
    });

    if (applicableData.length === 0) return false;

    // Check if ALL applicable data rows are in the selected set
    return applicableData.every((row) =>
      selectedIds.has(row[props.uniqeKeyName])
    );
  };

  // Check if some (but not all) data is selected
  const areSomeDataSelected = () => {
    const allData = filteredData || [];
    if (allData.length === 0) return false;

    const selectedRows =
      state?.arrayDataCheckBoks[props.uniqeKeyNameRedux] || [];

    // Create a Set of selected row IDs
    const selectedIds = new Set(
      selectedRows.map((row) => row[props.uniqeKeyName])
    );

    // Filter data based on checkBoksCustomRender condition - SAME LOGIC AS handleSelectAll
    const applicableData = allData.filter((ele) => {
      if (props.checkBoksCustomRender) {
        return props.checkBoksCustomRenderKeyValue.includes(
          ele[props.checkBoksCustomRenderKeyName]
        )
          ? props.checkBoksCustomRenderKeyValue.includes(
              ele[props.checkBoksCustomRenderKeyName]
            ) && props.checkBoksCustomRenderShowOrHide
          : true;
      }
      return true;
    });

    if (applicableData.length === 0) return false;

    const selectedCount = applicableData.filter((row) =>
      selectedIds.has(row[props.uniqeKeyName])
    ).length;

    return selectedCount > 0 && selectedCount < applicableData.length;
  };

  // Function to get count of selected rows vs total rows
  const getSelectionInfo = () => {
    const allData = filteredData || [];
    const selectedRows =
      state?.arrayDataCheckBoks[props.uniqeKeyNameRedux] || [];

    // Filter data based on checkBoksCustomRender condition - SAME LOGIC AS handleSelectAll
    const applicableData = allData.filter((ele) => {
      if (props.checkBoksCustomRender) {
        return props.checkBoksCustomRenderKeyValue.includes(
          ele[props.checkBoksCustomRenderKeyName]
        )
          ? props.checkBoksCustomRenderKeyValue.includes(
              ele[props.checkBoksCustomRenderKeyName]
            ) && props.checkBoksCustomRenderShowOrHide
          : true;
      }
      return true;
    });

    const selectedCount = selectedRows.length;
    const totalCount = allData.length;

    if (props.lang === "ar") {
      return `تم تحديد ${selectedCount} من ${totalCount}`;
    } else {
      return `Selected ${selectedCount} of ${totalCount}`;
    }
  };

  // const HTMLCheckBoks=
  //////////////////////// render html ///////////////////////////
  return (
    <>
      <div className="tableContainer" id={props.tableId}>
        {props.tableHeader != true ? (
          <div className="headTable">
            <div className="CenterSection">
              {/*
              لاظهار واخفاء زر الاضافة في اعلى الجدول 
               */}
              {/* {props.tableBtn ? (
                <>
                  <button
                    onClick={() => {
                      if (!props.AddFunctionButtonPopup) {
                        setopenPopupState(true);
                      } else {
                        props.AddFunctionButtonPopupFunction();
                      }
                    }}
                    className="tableBtn"
                    title="اضافة"
                  >
                    <FontAwesomeIcon
                      icon={faSquarePlus}
                      style={{ color: "#f9a825" }}
                    />
                  </button>
                </>
              ) : (
                ""
              )} */}

              {/*
              عنوان الجدول 
               */}
              <h4 className="titelTable " title={props.titelTableTitle}>
                {props.lang !== "en" ? props.titelTable : props.titelTableEN}
              </h4>
            </div>

            <div className="rightSection">
              {/*
              قائمة الفلتر في اعلى الججول 
               */}
              {props.DropdownFiltration ? (
                <>
                  <div className="dropdown" ref={dropdownRef}>
                    <button
                      className="dropdown-toggle"
                      id="dropDownMenu"
                      onClick={toggleDropdown}
                    >
                      {props.lang !== "en" ? "🔽 اختر الخيارات " : "select 🔽"}
                    </button>
                    {isOpen && (
                      <div className="dropdown-content">
                        {Object.keys(groupingDropDown()).map((option, ind) => {
                          return (
                            <div
                              key={ind + "l"}
                              className="optionDropDownName"
                              onClick={() => {
                                // console.log(option, "sdsdwdwddsd");

                                SetvalueFilterSupDropDown(option);
                                setHideDropDown("");
                              }}
                            >
                              {option}
                            </div>
                          );
                        })}

                        <div className={`supDropDown ${hideDropDown}`}>
                          {[
                            ...new Map(
                              options.map((item) => [item.label, item])
                            ).values(),
                          ]
                            .filter(
                              (option) =>
                                option.groping === valueFilterSupDropDown
                            )
                            .map((option, ind) => (
                              <label key={ind}>
                                <div></div>
                                <input
                                  type="checkbox"
                                  id={`checkbox${ind}`}
                                  checked={selectedOptions.some(
                                    (selected) =>
                                      selected.value === option.value
                                  )}
                                  onChange={(e) => {
                                    handleCheckboxChange(option, e);
                                    // console.log(option, "sdjkijiwudiud");
                                  }}
                                />
                                {option.label}
                              </label>
                            ))}
                        </div>
                      </div>
                    )}
                  </div>
                </>
              ) : (
                ""
              )}

              {props.search ? (
                <>
                  <div className="input-wrapper">
                    <FontAwesomeIcon icon={faSearch} className="search-icon" />
                    <input
                      id="searchInput"
                      // placeholder="بحث"
                      // placeholder="🔍 بحث"
                      placeholder={props.lang !== "en" ? "ابحث هنا" : "search"}
                      onChange={(e) => {
                        handelSearch(e);
                        setSearchValue(e.target.value);
                      }}
                      disabled={false}
                    />{" "}
                    {/* <label id="searchIcon">
                    <BiSearch />
                  </label> */}
                  </div>
                </>
              ) : (
                ""
              )}
            </div>
          </div>
        ) : (
          ""
        )}
        <div className="bodyTable" id={props.id}>
          {props.TableComponent ? (
            <div className="TableComponent">{props.TableComponent}</div>
          ) : (
            ""
          )}
          <table>
            <thead className="head_table" dir="rtl">
              <tr>
                {props.checkBoks ? (
                  <th className="chexkBoxColum">
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        whiteSpace: "nowrap",
                        padding: "5px",
                      }}
                    >
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <input
                          type="checkbox"
                          className="select-all-checkbox"
                          checked={areAllDataSelected()}
                          ref={(checkboxRef) => {
                            if (checkboxRef) {
                              checkboxRef.indeterminate = areSomeDataSelected();
                            }
                          }}
                          onChange={handleSelectAll}
                          title={
                            props.lang === "ar" ? "تحديد الكل" : "Select All"
                          }
                        />
                        {props.checkBoksColumName && (
                          <span
                            style={{
                              marginLeft: "8px",
                              fontSize: "1rem",
                              paddingRight: "5px",
                            }}
                          >
                            {props.checkBoksColumName}
                          </span>
                        )}
                      </div>

                      {/* Optional: Show selection count */}
                      {filteredData?.length > 0 && (
                        <div
                          style={{
                            fontSize: ".80rem",
                            color: "#666",
                            textAlign: "center",
                          }}
                        >
                          {getSelectionInfo()}
                        </div>
                      )}
                    </div>
                  </th>
                ) : (
                  ""
                )}
                {arrayButton && arrayButton.length > 0 ? (
                  <th
                    id="actionColumn"
                    style={{
                      backgroundColor: props.tableBtn
                        ? hover
                          ? "#62bae9" // hover color when tableBtn = true
                          : "#f9a825" // normal color when tableBtn = true
                        : "#def0f08f", // when tableBtn = false
                      transition: "transform 0.2s ease-in-out",
                    }}
                    onMouseEnter={() => props.tableBtn && setHover(true)}
                    onMouseLeave={() => props.tableBtn && setHover(false)}
                  >
                    {props.nameColumAction || props.tableBtn ? (
                      <>
                        <button
                          onClick={() => {
                            if (!props.AddFunctionButtonPopup) {
                              setopenPopupState(true);
                            } else {
                              props.AddFunctionButtonPopupFunction();
                            }
                          }}
                          className="tableBtn"
                          title={props.lang === "ar" ? "إضافة" : "Add"}
                        >
                          <FontAwesomeIcon
                            icon={faSquarePlus}
                            // style={{ color: "#0095DA" }}
                            style={{ color: "#fff" }}
                          />
                          <span
                            className="hoverColor"
                            // style={{ color: "#192569f7" }}
                            style={{ color: "#fff" }}
                          >
                            {props.lang === "ar" ? "إضافة" : "Add"}
                          </span>
                        </button>
                      </>
                    ) : (
                      ""
                    )}
                  </th>
                ) : (
                  ""
                )}
                {props.accessor.map((ele, ind) => {
                  if (ele.ShowStatus) {
                    return props.sort ? (
                      props.arrayNameSort.includes(ele.NmaeColumn) ? (
                        <th>
                          {ele}{" "}
                          <label>
                            {stateSort === "Descending" ? (
                              // <TbSortAscending />
                              <></>
                            ) : (
                              // <PiSortAscendingFill />
                              <></>
                            )}
                          </label>
                        </th>
                      ) : (
                        <th>
                          {props.lang !== "en"
                            ? ele.NmaeColumn
                            : ele.NmaeColumnEN}
                        </th>
                      )
                    ) : (
                      <th>
                        {props.lang == "ar" ? ele.NmaeColumn : ele.NmaeColumnEN}
                      </th>
                    );
                  }
                })}

                {/* {props.checkBoks ? (
                  <th className="chexkBoxColum">{props.checkBoksColumName}</th>
                ) : (
                  ""
                )} */}
              </tr>
            </thead>

            {/* 3️⃣ JSX لعرض الجدول */}

            <tbody>
              {(props.mergeColumns
                ? groupDataByKeys(filteredData, props.mergeColumns)
                    ?.slice(stebPagination, endpagination)
                    .flatMap((group, groupIndex) =>
                      group.map((row, rowIndex) => ({
                        row,
                        groupLength: group.length,
                        rowIndex,
                      }))
                    )
                : filteredData
                    ?.slice(stebPagination, endpagination)
                    .map((row, rowIndex) => ({
                      row,
                      groupLength: 1,
                      rowIndex,
                    }))
              ).map(
                ({ row, groupLength, rowIndex }, idx) => (
                  console.log(row, "rowwwwwwwwwwwwwwwwwwwwww"),
                  (
                    <tr
                      key={idx + "O"}
                      data-group={idx}
                      className={`
                      group-${idx} 
    ${groupLength > 1 ? "merged-row-highlight" : ""}
    ${rowIndex === 0 ? "first-in-group" : ""}
    ${rowIndex === groupLength - 1 ? "last-in-group" : ""}
  `}
                    >
                      {props.checkBoks ? (
                        <>
                          <>
                            <td className="checkBoxColum">
                              {props.checkBoksCustomRender ? (
                                <>
                                  {props.checkBoksCustomRenderKeyValue.includes(
                                    row[props.checkBoksCustomRenderKeyName]
                                  ) ? (
                                    <>
                                      {props.checkBoksCustomRenderShowOrHide ==
                                      true ? (
                                        <input
                                          name={row[props.uniqeKeyName]}
                                          className="checkboxList"
                                          type="checkbox"
                                          id={row[props.uniqeKeyName]}
                                          checked={state?.arrayDataCheckBoks[
                                            props.uniqeKeyNameRedux
                                          ]?.some(
                                            (item) =>
                                              item[props.uniqeKeyName] ===
                                              row[props.uniqeKeyName]
                                          )}
                                          onChange={(e) => {
                                            console.log(row, "rowrow");

                                            if (e.target.checked) {
                                              dispatch(
                                                SetArrayDataCheckBoks({
                                                  array: [
                                                    ...(state
                                                      ?.arrayDataCheckBoks[
                                                      props.uniqeKeyNameRedux
                                                    ] || []),
                                                    row,
                                                  ],
                                                  KeyName:
                                                    props.uniqeKeyNameRedux,
                                                })
                                              );
                                            } else {
                                              dispatch(
                                                SetArrayDataCheckBoks({
                                                  array:
                                                    state?.arrayDataCheckBoks[
                                                      props.uniqeKeyNameRedux
                                                    ].filter(
                                                      (item) =>
                                                        item[
                                                          props.uniqeKeyName
                                                        ] !==
                                                        row[props.uniqeKeyName]
                                                    ),
                                                  KeyName:
                                                    props.uniqeKeyNameRedux,
                                                })
                                              );
                                            }
                                          }}
                                        />
                                      ) : (
                                        <></>
                                      )}
                                    </>
                                  ) : (
                                    <>
                                      <input
                                        name={row[props.uniqeKeyName]}
                                        className="checkboxList"
                                        type="checkbox"
                                        id={row[props.uniqeKeyName]}
                                        checked={state?.arrayDataCheckBoks[
                                          props.uniqeKeyNameRedux
                                        ]?.some(
                                          (item) =>
                                            item[props.uniqeKeyName] ===
                                            row[props.uniqeKeyName]
                                        )}
                                        onChange={(e) => {
                                          console.log(row, "rowrow");

                                          if (e.target.checked) {
                                            dispatch(
                                              SetArrayDataCheckBoks({
                                                array: [
                                                  ...(state?.arrayDataCheckBoks[
                                                    props.uniqeKeyNameRedux
                                                  ] || []),
                                                  row,
                                                ],
                                                KeyName:
                                                  props.uniqeKeyNameRedux,
                                              })
                                            );
                                          } else {
                                            dispatch(
                                              SetArrayDataCheckBoks({
                                                array:
                                                  state?.arrayDataCheckBoks[
                                                    props.uniqeKeyNameRedux
                                                  ].filter(
                                                    (item) =>
                                                      item[
                                                        props.uniqeKeyName
                                                      ] !==
                                                      row[props.uniqeKeyName]
                                                  ),
                                                KeyName:
                                                  props.uniqeKeyNameRedux,
                                              })
                                            );
                                          }
                                        }}
                                      />
                                    </>
                                  )}
                                </>
                              ) : (
                                <>
                                  <input
                                    name={row[props.uniqeKeyName]}
                                    className="checkboxList"
                                    type="checkbox"
                                    id={row[props.uniqeKeyName]}
                                    checked={state?.arrayDataCheckBoks[
                                      props.uniqeKeyNameRedux
                                    ]?.some(
                                      (item) =>
                                        item[props.uniqeKeyName] ===
                                        row[props.uniqeKeyName]
                                    )}
                                    onChange={(e) => {
                                      console.log(row, "rowrow");

                                      if (e.target.checked) {
                                        dispatch(
                                          SetArrayDataCheckBoks({
                                            array: [
                                              ...(state?.arrayDataCheckBoks[
                                                props.uniqeKeyNameRedux
                                              ] || []),
                                              row,
                                            ],
                                            KeyName: props.uniqeKeyNameRedux,
                                          })
                                        );
                                      } else {
                                        dispatch(
                                          SetArrayDataCheckBoks({
                                            array: state?.arrayDataCheckBoks[
                                              props.uniqeKeyNameRedux
                                            ].filter(
                                              (item) =>
                                                item[props.uniqeKeyName] !==
                                                row[props.uniqeKeyName]
                                            ),
                                            KeyName: props.uniqeKeyNameRedux,
                                          })
                                        );
                                      }
                                    }}
                                  />
                                </>
                              )}
                            </td>
                          </>
                        </>
                      ) : (
                        ""
                      )}
                      {/* الأزرار - عمود مدموج */}

                      {allowMerge(row, rowIndex) ? (
                        <td className={`actionButton `} rowSpan={groupLength}>
                          {arrayButton &&
                            arrayButton.map((ele, ind) => {
                              console.log(
                                props.mergeColumns?.length,
                                groupLength,
                                1,
                                "rowooooowooo"
                              );
                              // const isMergedColbtn = props.mergeColumns?.length;
                              // if (isMergedColbtn && rowIndex > 0) return null; // تجاهل الصفوف المكررة

                              if (props.RequestsManagerValue) {
                                if (ele.caneEditValue) {
                                  if (row.canEdit && ele.ShowStatus) {
                                    return (
                                      <>
                                        <button
                                          value={JSON.stringify(row)}
                                          onClick={ele.Click}
                                          id={ele.id}
                                          className={`buttonActionColumn ${ele.className}`}
                                          title={ele.title}
                                        >
                                          <>{ele.content} </>
                                        </button>
                                      </>
                                    );
                                  } else {
                                    return <></>;
                                  }
                                }

                                if (props.AllValueAction && ele.ShowStatus) {
                                  return (
                                    <>
                                      <button
                                        value={JSON.stringify(row)}
                                        onClick={ele.Click}
                                        id={ele.id}
                                        className={`buttonActionColumn ${ele.className}`}
                                        title={ele.title}
                                      >
                                        <>{ele.content} </>
                                      </button>
                                    </>
                                  );
                                }
                              } else if (ele.caneEditValue) {
                                if (row.canEdit && ele.ShowStatus) {
                                  return (
                                    <>
                                      <button
                                        value={JSON.stringify(row)}
                                        onClick={ele.Click}
                                        id={ele.id}
                                        className={`buttonActionColumn ${ele.className}`}
                                        title={ele.title}
                                      >
                                        <>{ele.content} </>
                                      </button>
                                    </>
                                  );
                                } else {
                                  return <></>;
                                }
                              } else if (ele.byStatusShowOrHide) {
                              } else if (
                                ele.InitialScreeningAssessment &&
                                ele.ShowStatus
                              ) {
                                return (
                                  <>
                                    <button
                                      value={JSON.stringify(row)}
                                      onClick={ele.Click}
                                      id={ele.id}
                                      className={`buttonActionColumn ${ele.className}`}
                                      title={ele.title}
                                    >
                                      <>{ele.content} </>
                                    </button>
                                  </>
                                );
                              } else if (ele.ShowHideByCanEdit) {
                                if (ele.ShowHideByUser) {
                                  if (row.canEdit) {
                                    return (
                                      <>
                                        <button
                                          value={JSON.stringify(row)}
                                          onClick={ele.Click}
                                          id={ele.id}
                                          className={`buttonActionColumn ${ele.className}`}
                                          title={ele.title}
                                        >
                                          <>{ele.content} </>
                                        </button>
                                      </>
                                    );
                                  }
                                } else {
                                  return <></>;
                                }
                              } else if (ele.InitialScreeningAssessment_) {
                              } else if (ele.ShowStatus) {
                                if (
                                  ele.ForSpecificLineStatus === true &&
                                  row[ele.ForSpecificLineName] ==
                                    ele.ForSpecificLineId
                                ) {
                                  return (
                                    <button
                                      value={JSON.stringify(row)}
                                      onClick={ele.Click}
                                      title={ele.title}
                                      id={ele.id}
                                      className={`buttonActionColumn ${ele.className}`}
                                    >
                                      <>{ele.content} </>
                                    </button>
                                  );
                                } else if (
                                  row[ele.ForSpecificLineName] ==
                                    "00000000-0000-0000-0000-000000000000" &&
                                  ele.id == "editBtn"
                                ) {
                                  return <></>;
                                } else if (props.lastButton && ele.ShowLast) {
                                  if (
                                    // props.lengthReportsStages ==
                                    filteredData[filteredData.length - 1] == row
                                  ) {
                                    return (
                                      <button
                                        value={JSON.stringify(row)}
                                        onClick={ele.Click}
                                        id={ele.id}
                                        className={`buttonActionColumn ${ele.className}`}
                                        title={ele.title}
                                      >
                                        <>{ele.content} </>
                                      </button>
                                    );
                                  }
                                } else if (!ele.ForSpecificLineStatus) {
                                  if (props.KeyCondition) {
                                    if (
                                      row[props.KeyCondition] ==
                                      props.modelCondition[props.KeyCondition]
                                    ) {
                                      if (props.btnNotToShow != ele.id) {
                                        // console.log("resssssss");
                                        return (
                                          <button
                                            value={JSON.stringify(row)}
                                            onClick={ele.Click}
                                            id={ele.id}
                                            title={ele.title}
                                            className={`buttonActionColumn ${ele.className}`}
                                          >
                                            <>{ele.content} </>
                                          </button>
                                        );
                                      }
                                    } else {
                                      return (
                                        <button
                                          value={JSON.stringify(row)}
                                          title={ele.title}
                                          onClick={ele.Click}
                                          id={ele.id}
                                          className={`buttonActionColumn ${ele.className}`}
                                        >
                                          <>{ele.content} </>
                                        </button>
                                      );
                                    }
                                  }
                                  if (ele?.keyNameTarget) {
                                    return (
                                      <button
                                        value={row[ele?.keyNameTarget]}
                                        onClick={ele.Click}
                                        id={ele.id}
                                        className={`buttonActionColumn ${ele.className}`}
                                        title={ele.title}
                                      >
                                        <>{ele.content} </>
                                      </button>
                                    );
                                    //هذه الجزئية للتحكم في اظهار btn على حسب قيمة معينة
                                  } else if (ele.ShowHideBtn) {
                                    let isVisible = false;

                                    if (Array.isArray(ele.ShowHideBtn)) {
                                      // لازم كل الشروط تتحقق
                                      isVisible = ele.ShowHideBtn.every(
                                        (condition) => {
                                          if (condition.Condition == "Not") {
                                            return (
                                              condition.statusToWork === true &&
                                              row[condition?.KeyName] !=
                                                condition.Value
                                            );
                                          } else {
                                            return (
                                              condition.statusToWork === true &&
                                              row[condition?.KeyName] ==
                                                condition.Value
                                            );
                                          }
                                        }
                                      );
                                    } else {
                                      // حالة شرط واحد فقط
                                      isVisible =
                                        ele.ShowHideBtn.statusToWork === true &&
                                        row[ele.ShowHideBtn?.KeyName] ==
                                          ele.ShowHideBtn.Value;
                                    }

                                    if (isVisible) {
                                      return (
                                        <button
                                          value={JSON.stringify(row)}
                                          title={ele.title}
                                          onClick={ele.Click}
                                          id={ele.id}
                                          className={`buttonActionColumn ${ele.className}`}
                                        >
                                          <>{ele.content} </>
                                          {/* <motion.div
                                        whileHover={{
                                          scale: 1.3,
                                          rotate: -20,
                                          color: "red",
                                        }}
                                        whileTap={{ scale: 0.9 }}
                                        transition={{
                                          type: "spring",
                                          stiffness: 300,
                                        }}
                                      >
                                        <FontAwesomeIcon icon={faTrash} />
                                      </motion.div> */}
                                        </button>
                                      );
                                    } else {
                                      return <></>;
                                    }
                                  } else {
                                    return (
                                      <button
                                        value={JSON.stringify(row)}
                                        title={ele.title}
                                        onClick={ele.Click}
                                        id={ele.id}
                                        className={`buttonActionColumn ${ele.className}`}
                                      >
                                        {ele.content}{" "}
                                      </button>
                                    );
                                  }
                                }
                              }
                            })}
                        </td>
                      ) : (
                        ""
                      )}
                      {/* ///////////////////////////////////////////////////هنا الجزئية الخاصة في الصفوف//////////////////////////////////// */}
                      {props.accessor.map((col, colIndex) => {
                        if (!col.ShowStatus) return null;
                        const isGroupFirst = rowIndex === 0;
                        const isGroupLast = rowIndex === groupLength - 1;
                        const cellValue = row[col?.KeyName];
                        const isMergedCol = props.mergeColumns?.includes(
                          col?.KeyName
                        );
                        if (isMergedCol && rowIndex > 0) return null; // تجاهل الصفوف المكررة
                        const rowSpan = isMergedCol ? groupLength : 1;

                        const renderContent = () => {
                          if (col.comma) return numberWithCommas(cellValue);
                          if (
                            col?.KeyName === props.dateKey ||
                            col?.KeyName === props.dateKey2
                          )
                            return moment(cellValue).format(props.dateformat);
                          if (col.typeColumn === "file" && cellValue !== null) {
                            console.log(cellValue, "cellValue");
                            if (cellValue == "null")
                              return props.lang != "en"
                                ? "لا يوجد مرفق"
                                : "No Attach";
                            const fileStore = props.fileStoreName;
                            return (
                              <Link
                                target="_blank"
                                className="AttachmentTable"
                                to={`${jsonData.domainUrl}/${fileStore}/${cellValue}`}
                              >
                                <button className="open-file">
                                  <span className="file-wrapper">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      fill="none"
                                      viewBox="0 0 71 67"
                                    >
                                      <path
                                        strokeWidth="5"
                                        stroke="black"
                                        d="M41.7322 11.7678L42.4645 12.5H43.5H68.5V64.5H2.5V2.5H32.4645L41.7322 11.7678Z"
                                      />
                                    </svg>
                                    <span className="file-front"></span>
                                  </span>
                                </button>
                              </Link>
                            );
                          }
                          if (cellValue === true) return props.trueText;
                          if (cellValue === false) return props.falseText;
                          return cellValue;
                        };

                        return (
                          <td
                            key={colIndex}
                            rowSpan={rowSpan}
                            className={isMergedCol ? "merged-cellTd" : ""}

                            // className={
                            //   isMergedCol ??
                            //   `merged ${isGroupFirst ? "first-in-group" : ""} ${
                            //     isGroupLast ? "last-in-group" : ""
                            //   }`
                            // }
                          >
                            {isMergedCol ? (
                              <div className="merged-cell">
                                {renderContent()}
                              </div>
                            ) : (
                              renderContent()
                            )}
                          </td>
                        );
                      })}
                      {/* جزئية خاصة بعرض الازرار في نهاية الجدول */}
                      {props.showActionButtonLast ? (
                        <td className="actionButton">
                          {arrayButtonLast &&
                            arrayButtonLast.map((ele, ind) => {
                              console.log(row, "rowoooooooo");

                              if (props.RequestsManagerValue) {
                                if (ele.caneEditValue) {
                                  if (row.canEdit && ele.ShowStatus) {
                                    return (
                                      <>
                                        <button
                                          value={JSON.stringify(row)}
                                          onClick={ele.Click}
                                          id={ele.id}
                                          className={`buttonActionColumn ${ele.className}`}
                                          title={ele.title}
                                        >
                                          <>{ele.content} </>
                                        </button>
                                      </>
                                    );
                                  } else {
                                    return <></>;
                                  }
                                }

                                if (props.AllValueAction && ele.ShowStatus) {
                                  return (
                                    <>
                                      <button
                                        value={JSON.stringify(row)}
                                        onClick={ele.Click}
                                        id={ele.id}
                                        className={`buttonActionColumn ${ele.className}`}
                                        title={ele.title}
                                      >
                                        <>{ele.content} </>
                                      </button>
                                    </>
                                  );
                                }
                              } else if (ele.caneEditValue) {
                                if (row.canEdit && ele.ShowStatus) {
                                  return (
                                    <>
                                      <button
                                        value={JSON.stringify(row)}
                                        onClick={ele.Click}
                                        id={ele.id}
                                        className={`buttonActionColumn ${ele.className}`}
                                        title={ele.title}
                                      >
                                        <>{ele.content} </>
                                      </button>
                                    </>
                                  );
                                } else {
                                  return <></>;
                                }
                              } else if (ele.byStatusShowOrHide) {
                              } else if (
                                ele.InitialScreeningAssessment &&
                                ele.ShowStatus
                              ) {
                                return (
                                  <>
                                    <button
                                      value={JSON.stringify(row)}
                                      onClick={ele.Click}
                                      id={ele.id}
                                      className={`buttonActionColumn ${ele.className}`}
                                      title={ele.title}
                                    >
                                      <>{ele.content} </>
                                    </button>
                                  </>
                                );
                              } else if (ele.ShowHideByCanEdit) {
                                if (ele.ShowHideByUser) {
                                  if (row.canEdit) {
                                    return (
                                      <>
                                        <button
                                          value={JSON.stringify(row)}
                                          onClick={ele.Click}
                                          id={ele.id}
                                          className={`buttonActionColumn ${ele.className}`}
                                          title={ele.title}
                                        >
                                          <>{ele.content} </>
                                        </button>
                                      </>
                                    );
                                  }
                                } else {
                                  return <></>;
                                }
                              } else if (ele.InitialScreeningAssessment_) {
                              } else if (ele.ShowStatus) {
                                if (
                                  ele.ForSpecificLineStatus === true &&
                                  row[ele.ForSpecificLineName] ==
                                    ele.ForSpecificLineId
                                ) {
                                  return (
                                    <button
                                      value={JSON.stringify(row)}
                                      onClick={ele.Click}
                                      title={ele.title}
                                      id={ele.id}
                                      className={`buttonActionColumn ${ele.className}`}
                                    >
                                      <>{ele.content} </>
                                    </button>
                                  );
                                } else if (
                                  row[ele.ForSpecificLineName] ==
                                    "00000000-0000-0000-0000-000000000000" &&
                                  ele.id == "editBtn"
                                ) {
                                  return <></>;
                                } else if (props.lastButton && ele.ShowLast) {
                                  if (
                                    // props.lengthReportsStages ==
                                    filteredData[filteredData.length - 1] == row
                                  ) {
                                    return (
                                      <button
                                        value={JSON.stringify(row)}
                                        onClick={ele.Click}
                                        id={ele.id}
                                        className={`buttonActionColumn ${ele.className}`}
                                        title={ele.title}
                                      >
                                        <>{ele.content} </>
                                      </button>
                                    );
                                  }
                                } else if (!ele.ForSpecificLineStatus) {
                                  if (props.KeyCondition) {
                                    if (
                                      row[props.KeyCondition] ==
                                      props.modelCondition[props.KeyCondition]
                                    ) {
                                      if (props.btnNotToShow != ele.id) {
                                        // console.log("resssssss");
                                        return (
                                          <button
                                            value={JSON.stringify(row)}
                                            onClick={ele.Click}
                                            id={ele.id}
                                            title={ele.title}
                                            className={`buttonActionColumn ${ele.className}`}
                                          >
                                            <>{ele.content} </>
                                          </button>
                                        );
                                      }
                                    } else {
                                      return (
                                        <button
                                          value={JSON.stringify(row)}
                                          title={ele.title}
                                          onClick={ele.Click}
                                          id={ele.id}
                                          className={`buttonActionColumn ${ele.className}`}
                                        >
                                          <>{ele.content} </>
                                        </button>
                                      );
                                    }
                                  }
                                  if (ele?.keyNameTarget) {
                                    return (
                                      <button
                                        value={row[ele?.keyNameTarget]}
                                        onClick={ele.Click}
                                        id={ele.id}
                                        className={`buttonActionColumn ${ele.className}`}
                                        title={ele.title}
                                      >
                                        <>{ele.content} </>
                                      </button>
                                    );
                                    //هذه الجزئية للتحكم في اظهار btn على حسب قيمة معينة
                                  } else if (ele.ShowHideBtn) {
                                    let isVisible = false;

                                    if (Array.isArray(ele.ShowHideBtn)) {
                                      // لازم كل الشروط تتحقق
                                      isVisible = ele.ShowHideBtn.every(
                                        (condition) => {
                                          if (condition.Condition == "Not") {
                                            return (
                                              condition.statusToWork === true &&
                                              row[condition?.KeyName] !=
                                                condition.Value
                                            );
                                          } else {
                                            return (
                                              condition.statusToWork === true &&
                                              row[condition?.KeyName] ==
                                                condition.Value
                                            );
                                          }
                                        }
                                      );
                                    } else {
                                      // حالة شرط واحد فقط
                                      isVisible =
                                        ele.ShowHideBtn.statusToWork === true &&
                                        row[ele.ShowHideBtn?.KeyName] ==
                                          ele.ShowHideBtn.Value;
                                    }

                                    if (isVisible) {
                                      return (
                                        <button
                                          value={JSON.stringify(row)}
                                          title={ele.title}
                                          onClick={ele.Click}
                                          id={ele.id}
                                          className={`buttonActionColumn ${ele.className}`}
                                        >
                                          <>{ele.content} </>
                                        </button>
                                      );
                                    } else {
                                      return <></>;
                                    }
                                  } else {
                                    return (
                                      <button
                                        value={JSON.stringify(row)}
                                        title={ele.title}
                                        onClick={ele.Click}
                                        id={ele.id}
                                        className={`buttonActionColumn ${ele.className}`}
                                      >
                                        {ele.content}{" "}
                                      </button>
                                    );
                                  }
                                }
                              }
                            })}
                        </td>
                      ) : (
                        ""
                      )}
                    </tr>
                  )
                )
              )}
              {/* // هنا يتم احتساب المجموع */}
              {props.total ? (
                <tr id="total">
                  <td>المجموع</td>
                  {/*  */}

                  {
                    ///////////////////////////////////////////////////////////////////////////////////// هنا جزئية الكبسات الخاصة في عامود ال action
                    props.accessor.map((ele, ind) => {
                      return (
                        <td>
                          {props.columnKeyNameArray.map((elememnt, ind) => {
                            console.log(
                              ele?.KeyName,
                              elememnt.keyName,
                              "sdsdsdsd"
                            );

                            return ele?.TotalNumber
                              ? calculatorColumn(ele?.KeyName)
                              : "";
                          })}
                        </td>
                      );
                    })
                  }
                </tr>
              ) : (
                ""
              )}
            </tbody>
          </table>
        </div>
        {props.pagination ? (
          <div className="pagination">
            <div className="slectShowRow">
              {props.selectRowNumber ? (
                <select
                  onChange={(e) => {
                    setEndPagination(parseInt(e.target.value));
                    setHalfPageNumber(parseInt(e.target.value));
                    setStebPagination(0);
                  }}
                >
                  <option value={5}>5</option>
                  <option value={10}>10</option>
                  <option value={15}>15</option>
                  <option value={20}>20</option>
                  <option value={25}>25</option>
                  <option value={30}>30</option>
                  <option value={50}>50</option>
                  <option value={100}>100</option>
                </select>
              ) : (
                ""
              )}

              {props.selectRpwNumber ? <label>عدد الصفوف الظاهرة</label> : ""}
            </div>

            <div className="rightSection">
              <button
                className="AiOutlineDoubleRight"
                onClick={() => {
                  if (stebPagination >= 5) {
                    setStebPagination(stebPagination - halfPageNumber);
                    setEndPagination(endpagination - halfPageNumber);
                  }
                }}
              >
                {!props.setEndPagination ? (
                  <>
                    {" "}
                    <AiOutlineDoubleRight />
                  </>
                ) : (
                  <></>
                )}
              </button>
              {!props.setEndPagination ? (
                <>
                  {props.lang !== "en" ? (
                    <label>
                      {" "}
                      صفحة {endpagination / halfPageNumber} - من{" "}
                      {Math.ceil(res.length / halfPageNumber)} صفحة
                    </label>
                  ) : (
                    <label>
                      {" "}
                      page {endpagination / halfPageNumber} - from page
                      {Math.ceil(res.length / halfPageNumber)}
                    </label>
                  )}
                </>
              ) : (
                <></>
              )}

              <button
                className="AiOutlineDoubleRight"
                onClick={() => {
                  if (endpagination <= res.length) {
                    setStebPagination(stebPagination + halfPageNumber);
                    setEndPagination(endpagination + halfPageNumber);
                  }
                }}
              >
                {!props.setEndPagination ? (
                  <>
                    <AiOutlineDoubleLeft />
                  </>
                ) : (
                  <></>
                )}
              </button>
            </div>

            <div className="leftSection"></div>
          </div>
        ) : (
          ""
        )}

        {props.paginationHide ? (
          <div className="pagination">
            <div className="rightSection">
              <button className="AiOutlineDoubleRight"></button>
            </div>

            <div className="leftSection"></div>
          </div>
        ) : (
          ""
        )}
      </div>
      {/*popup edite*/}
      <PopupAHSF
        // idButton={props.PopupOPjectData.idButton}
        isPopupOpenStatus={openPopupState}
        isPopupOpenFunction={() => {
          console.log(
            props.refreshDataFromClosePagePracticalExperiences,
            "wdwwwwwdwds"
          );

          if (
            props.setRefreshDataFromClosePagePracticalExperiences != undefined
          ) {
            if (props.refreshDataFromClosePagePracticalExperiences == false) {
              props.setRefreshDataFromClosePagePracticalExperiences(true);
            } else {
              props.setRefreshDataFromClosePagePracticalExperiences(false);
            }
          }
          if (
            props.setRefreshDataFromClosePageVoluntaryCommunityWork != undefined
          ) {
            if (props.refreshDataFromClosePageVoluntaryCommunityWork == false) {
              props.setRefreshDataFromClosePageVoluntaryCommunityWork(true);
            } else {
              props.setRefreshDataFromClosePageVoluntaryCommunityWork(false);
            }
          }
          setopenPopupState(false);
        }}
        lang={props.lang}
        title={props.PopupOPjectData.title}
        titleEN={props.PopupOPjectData.titleEN}
        componentBody={props.PopupOPjectData.componentBody}
        maxWidth={props.PopupOPjectData.maxWidth}
        maxHeight={props.PopupOPjectData.maxHeight}
      />
      {/*popup details*/}
      {props.popUpBody}
      {/* <PopupAHSF isPopupOpenStatus={props.openPopupState} isPopupOpenFunction={() => { setopenPopupState(false) }} title={props.title} componentBody={props.componentBody} maxWidth={props.maxWidth} maxHeight={props.maxHeight} /> */}
      {/*popup popup_1*/}
      {/* <PopupAHSF isPopupOpenStatus={openPopupState} isPopupOpenFunction={() => { setopenPopupState(false) }} title={"ssss"} componentBody={<></>} maxWidth={"500px"} maxHeight={"800px"} /> */}
      {/*popup popup_2*/}
      {/* <PopupAHSF isPopupOpenStatus={openPopupState} isPopupOpenFunction={() => { setopenPopupState(false) }} title={"ssss"} componentBody={<></>} maxWidth={"500px"} maxHeight={"800px"} /> */}
      {/*popup popup_3*/}
      {/* <PopupAHSF isPopupOpenStatus={openPopupState} isPopupOpenFunction={() => { setopenPopupState(false) }} title={"ssss"} componentBody={<></>} maxWidth={"500px"} maxHeight={"800px"} /> */}
      {/*popup popup_4*/}
      {/* <PopupAHSF isPopupOpenStatus={openPopupState} isPopupOpenFunction={() => { setopenPopupState(false) }} title={"ssss"} componentBody={<></>} maxWidth={"500px"} maxHeight={"800px"} /> */}
      {/*popup popup_5*/}
      {/* <PopupAHSF isPopupOpenStatus={openPopupState} isPopupOpenFunction={() => { setopenPopupState(false) }} title={"ssss"} componentBody={<></>} maxWidth={"500px"} maxHeight={"800px"} /> */}
      <LoaderAHSF show={loading} />
    </>
  );
};

export default TableAHSF;
